<template>
    <div class="call-to-action">
        <base-settings-row
            config-title="Button"
            input-type="checkbox"
            :fields-config="ctaCheckbox"
            :binded-value="settings.buttons"
            settings-key="buttons"
            @change="value => $emit('change', value)"
        />
        <div class="settings-field">
            <p class="title">
                Action:
            </p>
            <div class="options action-button-options">
                <div class="row-container">
                    <base-select
                        :options="ctaConfig"
                        :initial-value="settings.buttonConfig.cta.target"
                        :container-class="[
                            'is-large',
                            'button-action',
                            { disabled: ! hasCtaButton },
                        ]"
                        @change="value => $emit('cta-change', { target: value })"
                    />
                </div>
            </div>
        </div>
        <base-settings-row
            :class="[
                { disabled: ! hasCtaButton },
                'is-centered',
                'button-text',
            ]"
            config-title="Button"
            input-type="text"
            :fields-config="ctaButtonTextLabel"
            :binded-value="settings.buttonConfig.cta.label"
            settings-key="label"
            :label-class="['is-small']"
            @change="value => $emit('cta-change', { ...value })"
        />
        <base-settings-row
            :class="[
                { disabled: ! hasCtaButton },
                'is-centered',
                'button-url-field'
            ]"
            config-title="URL"
            input-type="text"
            :fields-config="ctaUrlConfig"
            :binded-value="settings.buttonConfig.cta.url"
            settings-key="url"
            @change="value => $emit('cta-change', { ...value} )"
        />
    </div>
</template>

<script>
import playerSettings from '@/utils/config/playerSettings';

const { ctaButton } = playerSettings;

export default {
    props: {
        settings: {
            type: Object,
            required: true,
        },

        show: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        ...ctaButton,

        ctaCheckbox: [
            {
                label: 'Show CTA button',
                value: 'cta',
            },
        ],
    }),

    computed: {
        /**
         * @returns  {boolean}  If has CTA button
         */
        hasCtaButton() {
            return this.settings.buttons.includes('cta');
        },
    },
};
</script>
